const middleware = {}

middleware['headers'] = require('../middleware/headers.ts')
middleware['headers'] = middleware['headers'].default || middleware['headers']

export default middleware
